export { getArticleServerSideProps } from './components/Article/getArticleServerSideProps';
export { ArticlePageTemplate } from './components/Article/ArticlePageTemplate';
export type { ArticlePageProps } from './components/Article/entities';

export { ProfileLayout } from './components/Profile/ProfileLayout';

export { getAuthorServerSideProps } from './components/Author/authorPageProps';
export { AuthorTemplate } from './components/Author/AuthorTemplate';
export type { AuthorTemplateProps } from './components/Author/AuthorTemplate';

export { CustomError } from './components/Error/Error';
